/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { toolsetsListForOrg } from "../funcs/toolsetsListForOrg.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListToolsetSummariesResult } from "../models/components/listtoolsetsummariesresult.js";
import {
  ListToolsetsForOrgRequest,
  ListToolsetsForOrgSecurity,
} from "../models/operations/listtoolsetsfororg.js";
import { unwrapAsync } from "../types/fp.js";
export type ListToolsetsForOrgQueryData = ListToolsetSummariesResult;

export function prefetchListToolsetsForOrg(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListToolsetsForOrgRequest | undefined,
  security?: ListToolsetsForOrgSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListToolsetsForOrgQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListToolsetsForOrgQuery(
  client$: GramCore,
  request?: ListToolsetsForOrgRequest | undefined,
  security?: ListToolsetsForOrgSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListToolsetsForOrgQueryData>;
} {
  return {
    queryKey: queryKeyListToolsetsForOrg({
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
    }),
    queryFn: async function listToolsetsForOrgQueryFn(
      ctx,
    ): Promise<ListToolsetsForOrgQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(toolsetsListForOrg(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListToolsetsForOrg(
  parameters: {
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "toolsets", "listForOrg", parameters];
}
